var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/afterpay/afterpay-info-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-afterpay__info-icon i-info\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" role=\"img\" aria-hidden=\"true\" data-qa-afterpay-info-icon>\n    <path d=\"M3.668,11.53125A6.04579,6.04579,0,0,1,.46875,8.332,5.83891,5.83891,0,0,1,0,6,5.83891,5.83891,0,0,1,.46875,3.668,6.04579,6.04579,0,0,1,3.668.46875,5.83891,5.83891,0,0,1,6,0,5.83891,5.83891,0,0,1,8.332.46875,6.04579,6.04579,0,0,1,11.53125,3.668,5.83891,5.83891,0,0,1,12,6a5.83891,5.83891,0,0,1-.46875,2.332A6.04579,6.04579,0,0,1,8.332,11.53125,5.83891,5.83891,0,0,1,6,12,5.83891,5.83891,0,0,1,3.668,11.53125ZM4.05469,1.35938A5.27331,5.27331,0,0,0,2.44922,2.4375,4.84138,4.84138,0,0,0,1.37109,4.043a5.14524,5.14524,0,0,0,0,3.91406A4.84138,4.84138,0,0,0,2.44922,9.5625a5.27331,5.27331,0,0,0,1.60547,1.07813,4.94807,4.94807,0,0,0,3.89063,0A5.27331,5.27331,0,0,0,9.55078,9.5625,4.84138,4.84138,0,0,0,10.62891,7.957a5.14524,5.14524,0,0,0,0-3.91406A4.84138,4.84138,0,0,0,9.55078,2.4375,5.27331,5.27331,0,0,0,7.94531,1.35938,4.94807,4.94807,0,0,0,4.05469,1.35938Zm2.4375,2.83594V3.14063H5.53125V4.19531H6.49219ZM6.49219,9V5.63867H5.53125V9H6.49219Z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/afterpay/afterpay-info-icon.j2"] , dependencies)